import { render, staticRenderFns } from "./Programa.vue?vue&type=template&id=21c94564&scoped=true&"
import script from "./Programa.vue?vue&type=script&lang=js&"
export * from "./Programa.vue?vue&type=script&lang=js&"
import style0 from "./Programa.vue?vue&type=style&index=0&id=21c94564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c94564",
  null
  
)

export default component.exports